// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__1vymK","card":"Home_card__1qUpw","fillHeight":"Home_fillHeight__2EUvn","centerMiddle":"Home_centerMiddle__2rXLM"};